import i18n from "@/i18n";

export const powerPlanFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true
    },
    {
        key: "numberOfSolutions",
        label: i18n.t("solution.numberOfSolutions"),
        sortable: true
    },
    {
        key: "actions",
        label: ""
    }
];
